export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 250; // Expanded sidebar width to match new design physics
export const SIDE_NAV_COLLAPSED_WIDTH = 65;

// Additional width options for different compact modes
export const SIDE_NAV_WIDTH_COMPACT = 200; // Professional compact mode
export const SIDE_NAV_WIDTH_ULTRA = 180; // Ultra compact mode
export const SIDE_NAV_WIDTH_MICRO = 160; // Micro compact mode
export const HEADER_HEIGHT = 60;
export const FOOTER_HEIGHT = 45;
export const TOP_NAV_HEIGHT = 65;
export const SIDE_NAV_LIGHT = 'SIDE_NAV_LIGHT';
export const SIDE_NAV_DARK = 'SIDE_NAV_DARK';
export const NAV_TYPE_SIDE = 'SIDE';
export const NAV_TYPE_TOP = 'TOP';
export const DIR_LTR = 'ltr';
export const DIR_RTL = 'rtl';
export const CONTENT_MAX_WIDTH = 1400;
export const CONTENT_HEIGHT_OFFSET = HEADER_HEIGHT + FOOTER_HEIGHT;
// 🎨 HEADER COLOR OPTIONS - Choose one by uncommenting:
// 📌 ORIGINAL COLOR (Easy Rollback): '#241A30' - Dark Purple

// 1. ✨ ENHANCED ORIGINAL COLOR - MAKE IT STAND OUT!
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#2d1f3d'; // Slightly lighter & more vibrant original
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#321d42'; // Richer, more saturated original
export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#241A30'; // 🔙 EXACT ORIGINAL with enhanced effects!

// 🌟 MORE ORIGINAL COLOR VARIATIONS (All get enhanced effects):
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#2a1e36'; // Warmer original
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#1f1529'; // Deeper original
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#2f1d3a'; // Brighter original

// 2. 🔵 COLORS THAT COMPLEMENT YOUR VLM UI DESIGN
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#1a3353'; // Matches your GRAY_DARK - Perfect harmony!
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#455560'; // Matches your GRAY - Subtle & professional
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#3e79f7'; // Matches your BLUE_BASE - Brand consistency!
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#a461d8'; // Matches your PURPLE_BASE - Similar to original
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#21B573'; // Matches your GREEN_BASE - Fresh & modern

// 2. 🎯 ENHANCED VERSIONS OF YOUR EXISTING COLORS
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#2c5aa0'; // Deeper version of your blue
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#8a4baf'; // Refined version of your purple
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#1e9960'; // Sophisticated green
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#c9302c'; // Enhanced red (matches your RED_BASE tone)

// 3. 🌟 MODERN PROFESSIONAL (Previous Recommendations)
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#1e40af'; // Deep professional blue
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#2563eb'; // Vibrant blue
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#1d4ed8'; // Rich blue

// 4. 🎨 SOPHISTICATED GRADIENTS (For advanced styling)
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = 'linear-gradient(135deg, #3e79f7 0%, #241A30 100%)'; // Your brand colors!
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)';

// 5. 🌙 MODERN DARK THEMES
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#1a202c'; // Slate dark
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#2d3748'; // Charcoal
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#1a1a1a'; // Pure dark

// 6. 🔥 TRENDY COLORS 2024-2025
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#6366f1'; // Indigo (trending)
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#8b5cf6'; // Purple (luxury)
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#06b6d4'; // Cyan (modern)

// 7. 🔴 WARM PROFESSIONAL
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#dc2626'; // Bold red
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#ea580c'; // Orange
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#059669'; // Emerald green

// 📋 ORIGINAL & PREVIOUS COLORS (For Easy Rollback):
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#241A30'; // 🔙 ORIGINAL - Dark Purple
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#597afd'; // Previous blue
// export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#e6f7ff'; // Previous light blue

export const HEADER_BG_DEFAULT_COLOR_DARK = '#283142';
export const LAYOUT_CONTENT_GUTTER = 25;
export const LAYOUT_CONTENT_GUTTER_SM = 15;
// export const SIDE_NAV_DARK_BG_COLOR = '#001529'
export const SIDE_NAV_DARK_BG_COLOR = '#f9f5ea'

export const BLUE_BASE= '#3e79f7';
export const PURPLE_BASE= '#a461d8';
export const CYAN_BASE= '#04d182';
export const GREEN_BASE= '#21B573';
export const MAGENTA_BASE= '#eb2f96';
export const PINK_BASE= '#eb2f96';
export const RED_BASE= '#de4436';
export const ORANGE_BASE= '#fa8c16';
export const YELLOW_BASE= '#fadb14';
export const VOLCANO_BASE= '#ff6b72';
export const GEEK_BLUE_BASE= '#17bcff';
export const LIME_BASE= '#a0d911';
export const GOLD_BASE= '#ffc542';

export const WHITE = '#ffffff';
export const DARK = '#000000';
export const GRAY_DARK = '#1a3353';
export const GRAY = '#455560';
export const GRAY_LIGHT = '#72849a';
export const GRAY_LIGHTER = '#ededed';
export const GRAY_LIGHTEST = '#f7f7f8';

export const BODY_BACKGROUND = '#fafafb';

export const FONT_SIZE_BASE = 14;

// 🎨 ENHANCED NAVBAR DIMENSIONS - Compact professional design
export const NAVBAR_ENHANCED = {
    HEADER_HEIGHT: 51, // 64 * 0.8 = 51.2 ≈ 51
    HEADER_PADDING_X: 19, // 24 * 0.8 = 19.2 ≈ 19
    HEADER_PADDING_Y: 13, // 16 * 0.8 = 12.8 ≈ 13
    SIDE_NAV_ITEM_HEIGHT: 32, // Reduced from 35 to 32 for more compact design
    SIDE_NAV_ITEM_PADDING: 12, // Reduced from 13 to 12
    SIDE_NAV_GROUP_SPACING: 12, // Reduced from 19 to 12
    ICON_SIZE: 13, // Reduced from 14 to 13
    AVATAR_SIZE: 29, // 36 * 0.8 = 28.8 ≈ 29
    LOGO_HEIGHT: 26, // 32 * 0.8 = 25.6 ≈ 26
    // New compact mode values
    SIDE_NAV_FONT_SIZE: 11, // Standard compact font size
    SIDE_NAV_FONT_SIZE_ULTRA: 10, // Ultra compact mode font size
    SIDE_NAV_GROUP_FONT_SIZE: 9, // Group title font size
    SIDE_NAV_GROUP_FONT_SIZE_ULTRA: 8, // Ultra compact group title font size
}

// 🔤 ENHANCED TYPOGRAPHY SCALE - Professional font hierarchy (80% scaled)
export const TYPOGRAPHY_ENHANCED = {
    FONT_FAMILY_PRIMARY: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    FONT_FAMILY_MONO: "'JetBrains Mono', 'Fira Code', 'Monaco', monospace",

    // Font sizes following 1.25 scale ratio, optimized at 80% for elegance
    FONT_SIZE_XS: 9, // 11 * 0.8 = 8.8 ≈ 9
    FONT_SIZE_SM: 10, // 13 * 0.8 = 10.4 ≈ 10
    FONT_SIZE_BASE: 11, // 14 * 0.8 = 11.2 ≈ 11
    FONT_SIZE_MD: 13, // 16 * 0.8 = 12.8 ≈ 13
    FONT_SIZE_LG: 14, // 18 * 0.8 = 14.4 ≈ 14
    FONT_SIZE_XL: 16, // 20 * 0.8 = 16
    FONT_SIZE_2XL: 19, // 24 * 0.8 = 19.2 ≈ 19
    FONT_SIZE_3XL: 24, // 30 * 0.8 = 24

    // Line heights for optimal readability
    LINE_HEIGHT_TIGHT: 1.25,
    LINE_HEIGHT_NORMAL: 1.5,
    LINE_HEIGHT_RELAXED: 1.75,

    // Letter spacing for different contexts
    LETTER_SPACING_TIGHT: '-0.025em',
    LETTER_SPACING_NORMAL: '0',
    LETTER_SPACING_WIDE: '0.025em',
}

// 📏 ENHANCED SPACING SYSTEM - Based on 8px grid
export const SPACING_ENHANCED = {
    XS: 4,   // 0.25rem
    SM: 8,   // 0.5rem
    MD: 12,  // 0.75rem
    LG: 16,  // 1rem
    XL: 20,  // 1.25rem
    XXL: 24, // 1.5rem
    XXXL: 32, // 2rem
    XXXXL: 40, // 2.5rem
    XXXXXL: 48, // 3rem
}

export const TEMPLATE = {
    HEADER_HEIGHT,
    FOOTER_HEIGHT,
    TOP_NAV_HEIGHT,
    CONTENT_HEIGHT_OFFSET,
    SIDE_NAV_WIDTH,
    SIDE_NAV_COLLAPSED_WIDTH,
    SIDE_NAV_WIDTH_COMPACT,
    SIDE_NAV_WIDTH_ULTRA,
    SIDE_NAV_WIDTH_MICRO,
    SIDE_NAV_DARK_BG_COLOR,
    CONTENT_MAX_WIDTH,
    HEADER_BG_DEFAULT_COLOR_LIGHT,
    HEADER_BG_DEFAULT_COLOR_DARK,
    LAYOUT_CONTENT_GUTTER,
    LAYOUT_CONTENT_GUTTER_SM,
    NAV_TYPE_SIDE,
    NAV_TYPE_TOP,
    SIDE_NAV_LIGHT,
    SIDE_NAV_DARK,
    DIR_LTR,
    DIR_RTL,
    // Add enhanced constants
    NAVBAR_ENHANCED,
    TYPOGRAPHY_ENHANCED,
    SPACING_ENHANCED
}

export const THEME_COLOR = {
    BLUE: BLUE_BASE,
    PURPLE: PURPLE_BASE,
    CYAN: CYAN_BASE,
    GREEN: GREEN_BASE,
    MAGENTA: MAGENTA_BASE,
    PINK: PINK_BASE,
    RED: RED_BASE,
    ORANGE: ORANGE_BASE,
    YELLOW: YELLOW_BASE,
    VOLCANO: VOLCANO_BASE,
    GEEK_BLUE: GEEK_BLUE_BASE,
    LIME: LIME_BASE,
    GOLD: GOLD_BASE,
}

export const FONT_WEIGHT = {
    LIGHTER: 'lighter',
    LIGHT: 300,
    NORMAL: 400,
    SEMIBOLD: 500,
    BOLD: 'bold',
    BASE: 400,
    BOLDER: 'bolder'
}

export const FONT_SIZES = {
    BASE: FONT_SIZE_BASE,
    LG: FONT_SIZE_BASE + 2,
    SM: 12
}

export const SPACER = {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '3rem',
}

const BREAKPOINT = {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1400px',
    xxl: '1600px'
}

export const MEDIA_QUERIES = {
    DESKTOP: `(min-width: ${BREAKPOINT.xl})`,
    LAPTOP: `(max-width: ${BREAKPOINT.xxl})`,
    LAPTOP_ABOVE: `(min-width: ${BREAKPOINT.xxl})`,
    TABLET: `(max-width: ${BREAKPOINT.lg})`,
    MOBILE: `(max-width: ${BREAKPOINT.md})`,
}

export const BORDER = {
    BASE_COLOR: '#e6ebf1'
}

export const GRAY_SCALE = {
    DARK,
    WHITE,
    GRAY_DARK,
    GRAY,
    GRAY_LIGHT,
    GRAY_LIGHTER,
    GRAY_LIGHTEST
}

export const DARK_MODE =  {
    TEXT_COLOR: '#b4bed2',
    HEADING_COLOR: '#d6d7dc',
    BG_COLOR: '#283142',
    BORDER_BASE_COLOR: '#4d5b75',
    HOVER_BG_COLOR: '#364663',
    ACTIVE_BG_COLOR: '#293956',
    DROP_DOWN_SHADOW: '0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 58%), 0 9px 28px 8px rgb(0 0 0 / 15%)',
    HEADER_TRANSITION: 'background-color 0.3s ease, box-shadow 0.3s ease'
}
